/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AlertModel } from "../models/alert-model";
@Injectable({
  providedIn: "root",
})
class AlertsService extends __BaseService {
  static readonly alertsGetActiveAlertMessagesPath =
    "/api/Alerts/GetActiveAlertMessages";
  static readonly alertsGetAllAlertMessagesPath =
    "/api/Alerts/GetAllAlertMessages";
  static readonly alertsCreateAlertMessagePath =
    "/api/Alerts/CreateAlertMessage";
  static readonly alertsUpdateAlertMessagePath =
    "/api/Alerts/UpdateAlertMessage";
  static readonly alertsDeleteAlertMessagePath =
    "/api/Alerts/DeleteAlertMessage";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  alertsGetActiveAlertMessagesResponse(): __Observable<
    __StrictHttpResponse<Array<AlertModel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Alerts/GetActiveAlertMessages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AlertModel>>;
      })
    );
  }
  alertsGetActiveAlertMessages(): __Observable<Array<AlertModel>> {
    return this.alertsGetActiveAlertMessagesResponse().pipe(
      __map((_r) => _r.body as Array<AlertModel>)
    );
  }
  alertsGetAllAlertMessagesResponse(): __Observable<
    __StrictHttpResponse<Array<AlertModel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Alerts/GetAllAlertMessages`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AlertModel>>;
      })
    );
  }
  alertsGetAllAlertMessages(): __Observable<Array<AlertModel>> {
    return this.alertsGetAllAlertMessagesResponse().pipe(
      __map((_r) => _r.body as Array<AlertModel>)
    );
  }

  /**
   * @param params The `AlertsService.AlertsCreateAlertMessageParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `isActive`:
   */
  alertsCreateAlertMessageResponse(
    params: AlertsService.AlertsCreateAlertMessageParams
  ): __Observable<__StrictHttpResponse<AlertModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.message != null)
      __params = __params.set("message", params.message.toString());
    if (params.isActive != null)
      __params = __params.set("isActive", params.isActive.toString());
    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/Alerts/CreateAlertMessage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AlertModel>;
      })
    );
  }
  /**
   * @param params The `AlertsService.AlertsCreateAlertMessageParams` containing the following parameters:
   *
   * - `message`:
   *
   * - `isActive`:
   */
  alertsCreateAlertMessage(
    params: AlertsService.AlertsCreateAlertMessageParams
  ): __Observable<AlertModel> {
    return this.alertsCreateAlertMessageResponse(params).pipe(
      __map((_r) => _r.body as AlertModel)
    );
  }

  /**
   * @param msg undefined
   */
  alertsUpdateAlertMessageResponse(
    msg: AlertModel
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = msg;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/Alerts/UpdateAlertMessage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param msg undefined
   */
  alertsUpdateAlertMessage(msg: AlertModel): __Observable<null> {
    return this.alertsUpdateAlertMessageResponse(msg).pipe(
      __map((_r) => _r.body as null)
    );
  }

  /**
   * @param msg undefined
   */
  alertsDeleteAlertMessageResponse(
    msg: AlertModel
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = msg;
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/api/Alerts/DeleteAlertMessage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param msg undefined
   */
  alertsDeleteAlertMessage(msg: AlertModel): __Observable<null> {
    return this.alertsDeleteAlertMessageResponse(msg).pipe(
      __map((_r) => _r.body as null)
    );
  }
}

module AlertsService {
  /**
   * Parameters for AlertsCreateAlertMessage
   */
  export interface AlertsCreateAlertMessageParams {
    message?: null | string;
    isActive?: boolean;
  }
}

export { AlertsService };
